export const environment = {
  production: false,
  apiUrl: "https://b2b2c-api-uat.awpassistance.in",
  payuUrl: "https://sboxcheckout-static.citruspay.com/bolt/run/bolt.min.js",
  nsmCount: 1,
  rsmCount: 5,
  asmCount: 25,
  financeCount: 1,
  gCaptchaKey: "6LfDxacrAAAAAOEDreZWOW69dNMa5UYwqtmZ9_-i",
  gCaptchaSecret: "6LfDxacrAAAAALsO201upB7svBYKiMvdzvZMFeth",
  // gCaptchaKey: "6LcYqG0sAAAAALn77cEZtGTm1SgvXERh7TRhd8c-",
  // gCaptchaSecret: "6LcYqG0sAAAAAPcCPtIxR6olroVcz3SMRHeNnyUk",
  maxvehicleAge: 9,
};
